export const PREFERRED_ABBREVIATIONS_GENERIC = {
    'Extra': 'Ex',
};

export const PREFERRED_ABBREVIATIONS_SUBSET = {
    'Modern': 'Mod',
    'Small Caps': 'SC',
    'Lining Figures': 'LF',
    'Old-style Figures': 'OSF',
    'Tabular Figures': 'TF',
    'Central European': 'CE',
    'Expert': 'Exp',
    'Simple OpenType': 'sOT',
    'Swash': 'Swa',
    'Premium': 'Pre',
    'Alternates': 'Alt',
};

export const PREFERRED_ABBREVIATIONS_OPTICAL = {
    'Caption': 'Capt',
    'Subhead': 'Subhd',
    'Display': 'Disp',
    'Banner': 'Ban',
};

export const PREFERRED_ABBREVIATIONS_WEIGHT = {
    'Bold': 'Bd',
    'Hairline': 'Hair',
    'Thin': 'Thi',
    'Light': 'Lt',
    'Book': 'Bk',
    'Regular': 'Reg',
    'Medium': 'Med',
    'Semi Bold': 'Sem',
    'Black': 'Bla',
    'Extra Black': 'Ex Bla',
    'Ultra Black': 'Ult',
    'Extra Bold': 'Ex Bold',
    'Heavy': 'Hvy',
    'Ultra Light': 'Ult Lt',
};

export const PREFERRED_ABBREVIATIONS_WIDTH = {
    'Compressed': 'Comp',
    'Condensed': 'Cond',
    'Narrow': 'Nar',
    'Normal': 'Nrm',
    'Wide': 'Wd',
    'Extended': 'Extd',
    'Ultra Condensed': 'Ult Cnd',
};

export const PREFERRED_ABBREVIATIONS_POSTURE = {
    'Italic': 'It',
    'Roman': 'Rom',
};

export const PREFERRED_ABBREVIATIONS = Object.assign({},
    PREFERRED_ABBREVIATIONS_GENERIC,
    PREFERRED_ABBREVIATIONS_SUBSET,
    PREFERRED_ABBREVIATIONS_OPTICAL,
    PREFERRED_ABBREVIATIONS_WEIGHT,
    PREFERRED_ABBREVIATIONS_WIDTH,
    PREFERRED_ABBREVIATIONS_POSTURE
);

export function abbreviateStyleName(name: string): string {
    const elements = name.split(' ').map(el => PREFERRED_ABBREVIATIONS[el] || el);
    return elements.join(' ');
}